import { Button, Input, Select, Switch, TableProps } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "../../../../assets/icons/AddIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../../utils/number";
import {
  selectSearchOption,
  selectStringOption,
} from "../../../../utils/utils";
import CreateGroupModal from "./CreateGroupModal";

export default function UserGroup() {
  const { page, limit, handlePagination, handleLimit } = useTable();
  const [switchStatus, setSwitchStatus] = useState(false);

  const { open, handleOpen, handleClose } = useModal();

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Group Role Name",
      dataIndex: "groupRoleName",
    },

    {
      title: "Product",
      dataIndex: "product",
      render: (val) => (
        <div className="justify-start text-blue-600 text-sm font-normal ">
          {val}
        </div>
      ),
    },
    {
      title: "Created at",
      dataIndex: "date",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 116,
      render: (value) => (
        <div className="flex gap-x-1">
          <Switch size="small" onChange={(val) => setSwitchStatus(val)} />
          <span className="">{switchStatus ? "Active" : "Inactive"}</span>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Link to={`/admin/users-roll-access/user-group/edit/${val}`}>
            <Button
              className="action-button"
              size="small"
              icon={<EditIcon />}
              // onClick={() =>
              //   handleOpen({
              //     type: "UPDATE",
              //     data: val,
              //   })
              // }
            />
          </Link>

          <Link to={`/admin/users-roll-access/user-group/details/${val}`}>
            <Button
              className="action-button"
              size="small"
              icon={<ViewIcon />}
            />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <SidebarLayout title="User Group List">
      {open.type === "ADD" && (
        <CreateGroupModal
          open={open.open}
          data={open?.data}
          type={open?.type}
          handleClose={handleClose}
        />
      )}
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={120} // Update total as per the data
        dataSource={data}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ width: 220 }}
            />

            <Select
              allowClear
              showSearch
              placeholder="All Product"
              filterOption={selectSearchOption}
              options={selectStringOption(["Digigo", "Pulse", "Bondhu"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectStringOption(["Active", "Inactive"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />

            <Link to={`/admin/users-roll-access/user-group/add`}>
              <Button
                type="primary"
                className="middle-button"
                icon={<AddIcon />}
              >
                Create a Group
              </Button>
            </Link>
          </>
        }
      />
    </SidebarLayout>
  );
}

interface DataType {
  product: string;
  groupRoleName: string;
  date: string;
  status: string;
  id: string;
}

const data: DataType[] = [
  {
    product: "Digigo",
    groupRoleName: "Business Admin",
    date: "10 Jan, 2025",
    status: "Active",
    id: "1",
  },
  {
    product: "Bondhu",
    groupRoleName: "Business Admin",
    date: "10 Jan, 2025",
    status: "Active",
    id: "2",
  },
  {
    product: "Pulse",
    groupRoleName: "Business Admin",
    date: "10 Jan, 2025",
    status: "Active",
    id: "3",
  },
];
